// extracted by mini-css-extract-plugin
export default {"text":"_2C4R","title":"_3ury","buttons":"_2ykS","icon":"_2n-i","sm":"_3yUU","lg":"_26FJ","md":"_14aL"};